import { gsap } from 'gsap/dist/gsap';

export function fullscreenNav() {

  const fullscreenNav = document.querySelector('[data-nav="fullscreen"]')
  const openButtons = Array.from(document.querySelectorAll('[data-action="open-fullscreen-nav"]'))
  const menuIcon = document.querySelector('.icon-menu')
  const closeIcon = document.querySelector('.icon-close')

  let state = 'closed'

  openButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tl = gsap.timeline()
  
      switch(state) {
        case 'closed':
          tl.to(menuIcon, { xPercent: 20, opacity: 0 })
          tl.to(fullscreenNav, { opacity: 1, pointerEvents: 'all' }, '>-0.3')
          tl.to(closeIcon, { scale: 1, opacity: 1 })
          state = 'open'
          break;
          case 'open':
          tl.to(closeIcon, { scale: 0.75, opacity: 0 })
          tl.to(fullscreenNav, { opacity: 0, pointerEvents: 'none' }, '>-0.3')
          tl.to(menuIcon, { xPercent: 0, opacity: 1 })
          state = 'closed'
          break;
        default:
      }
  
    })
  });

}


// WEBPACK FOOTER //
// ./scripts/animation/fullscreen-nav.js